<section class="container {{ currentStep.key }}">
	<header class="header">
		<div fxLayout.gt-md="row" fxAlign="center">
			<div fxFlex.gt-md="60%">
				<g-breadcrumb
					*ngIf="steps.length > 1"
					[steps]="steps"
					[selectedStep]="currentStep"
					[allowSelectAnyStep]="hasCartItem"
					[revertableStepKeys]="revertableStepKeys"
					[canAccessNextStep]="isStepStateValid$ | async"
					(onStepChange)="onBreadcrumbStepChange($event)"
				/>
				<div *ngIf="currentStep?.key === productPage.ProductDesigner" class="editor-info">
					<a
						[href]="editorInstructionsLink"
						target="_blank"
						rel="noopener"
						i18n="@@ProductEditorInstructions"
						>Editor instructions</a
					>
					<g-icon [icon]="icons.faCircleInfo" class="info-circle" />
				</div>
			</div>
			<div
				class="action-buttons-wrapper"
				fxFlex.gt-md="40%"
				fxLayout="column"
				fxLayoutGap="0px"
				fxLayoutGap.gt-xs="20px"
			>
				<nav
					class="action-buttons"
					*ngIf="steps.length"
					fxLayout="row"
					fxLayoutGap="0px"
					fxLayoutGap.gt-xs="20px"
					fxLayoutAlign.xs="space-between"
					fxLayoutAlign.gt-md="end"
				>
					<div
						*ngFor="let button; index as i; of: currentStepButtons$ | async"
						matTooltip="{{ buttonTooltipText$ | async }}"
						matTooltipClass="tooltip"
						placement="bottom"
						width="18rem"
						[matTooltipDisabled]="i > 0 || (isStepStateValid$ | async) || !(buttonTooltipText$ | async)"
					>
						<button
							type="button"
							class="btn"
							[attr.data-cy]="button.id + 'Button'"
							[ngClass]="[
								button.cssClass,
								button.iconSide === 'right' ? 'icon-side-right' : 'icon-side-left',
							]"
							(click)="callButtonAction(button)"
							[disabled]="button.isValidStateRequired ? !(isStepStateValid$ | async) : null"
						>
							@if (button.icon) {
								<g-icon [icon]="button.icon" />
							}
							<span class="btn-label">
								{{ button | getProductFlowButtonLabel: product : buttonLabelContext }}
							</span>
						</button>
					</div>
				</nav>
				<nav
					class="action-buttons-secondary"
					fxLayout="row"
					fxLayoutGap="0px"
					fxLayoutGap.gt-xs="20px"
					fxLayoutAlign.xs="space-between"
					fxLayoutAlign.gt-md="end"
					*ngIf="currentStepSecondaryButtons$ | async as secondaryButtons"
				>
					<button
						type="button"
						class="btn"
						[attr.data-cy]="button.id + 'Button'"
						*ngFor="let button; index as i; of: secondaryButtons"
						[ngClass]="[
							button.cssClass,
							button.iconSide === 'right' ? 'icon-side-right' : 'icon-side-left',
						]"
						[disabled]="button.isValidStateRequired ? !(isStepStateValid$ | async) : null"
						(click)="callButtonAction(button)"
					>
						<g-icon *ngIf="button.icon" [icon]="button.icon" />
						<span class="btn-label">
							{{ button | getProductFlowButtonLabel: product : buttonLabelContext }}
						</span>
					</button>
				</nav>
			</div>
		</div>
		<div
			class="validation-tooltip"
			data-cy="validationTooltip"
			*ngIf="validationTooltipText$ | async as validationTooltip"
			[ngClass]="{ show: validationTooltip.length > 0, hide: validationTooltip.length === 0 }"
		>
			{{ validationTooltip }}
		</div>
	</header>
	<section class="body">
		<div *ngIf="!(isLoading$ | async) && product" [ngSwitch]="currentStep?.key">
			<g-details
				*ngSwitchCase="productPage.ProductDetails"
				[product]="product"
				[category]="category"
				[showPrices]="showPrices"
				[showInternalInfo]="showInternalInfo"
				(selectedOptionsChanged)="onSelectedOptionsChange($event)"
				#productFlowPage
			/>
			<g-product-editor *ngSwitchCase="productPage.ProductDesigner" #productFlowPage />
			<g-workflow-selector
				*ngSwitchCase="productPage.Workflow"
				[product]="product"
				(onSelect)="onSelectWorkflow($event)"
				#productFlowPage
			/>
			<g-upload-material *ngSwitchCase="productPage.Upload" [product]="product" #productFlowPage />
			<g-design-service *ngSwitchCase="productPage.DesignService" [product]="product" #productFlowPage />
			<g-template-selector
				*ngSwitchCase="productPage.SelectTemplate"
				[product]="product"
				#productFlowPage
			/>
			<g-validate-design
				*ngSwitchCase="productPage.ValidateDesign"
				[product]="product"
				[showPrices]="showPrices"
				(selectedOptionsChanged)="onSelectedOptionsChange($event)"
				#productFlowPage
			/>
		</div>
		<div class="not-found" *ngIf="!(isLoading$ | async) && !product">
			<div class="info">
				<h1 i18n="NotFoundTitle">Product not found!</h1>
				<p i18n="NotFoundDescription">That's a good ol' 404.</p>
				<p><a [routerLink]="['/products']" i18n="NotFoundGoBack">Browse all products</a></p>
			</div>
			<div class="recommendations" *ngIf="recommendations$ | async">
				<g-product-list-thumbnail
					[products$]="recommendations$"
					[listingName]="dataLayer['NOT_FOUND_PAGE']"
				/>
			</div>
		</div>
	</section>
</section>
